import React from 'react';
import { Grid, Card, CardContent } from '@material-ui/core'; // adjust import path to match your MUI version/setup
import { InfoOutlined } from '@material-ui/icons'; // same here

const InfoBanner = ({ title = 'Important information:', items = [], style = {} }) => {
  if (!items || items.length === 0) return null;

  return (
      <Grid item xs={12} style={{ padding: 0, marginTop: '20px', ...style }}>
        <Card style={{ margin: 0 }}>
          <CardContent style={{ paddingBottom: 0 }}>
            <InfoOutlined style={{ color: 'rgb(0,79,113)' }} /> {title}
            <br /><br />
            <ul>
              {items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </Grid>
  );
};

export default InfoBanner;